export enum NotificationsPageTypeEnum {
  PAGE = "PAGE",
  PANEL = "PANEL",
}
